export function getStickySidebarTop(
  viewportHeight: number,
  sidebarHeight: number,
  topOffset: number,
  bottomOffset: number,
): number {
  if (!Number.isFinite(viewportHeight) || viewportHeight <= 0 || sidebarHeight <= 0) {
    return topOffset;
  }

  return Math.min(topOffset, viewportHeight - sidebarHeight - bottomOffset);
}
